<template lang="pug">
  .component.component-backoffice-driver-notification
    ModalReveal.p-0.m-0
      a.pr-2.fa.fa-qrcode.fa-2x(slot="trigger")

      .card
        .inner-content
          h2 Addd new Pass
          template
            .row
              .column
                label Name
                input(type="text", v-model="body.name")
                label Capabilities
                select(v-model="body.capabilities.routes", multiple)
                  option(v-for="route in capabilities" :value="route.value") {{route.label}}

              .column
                label Start
                date-picker(:pickTime="true", format="yyyy-mm-dd hh:ii", v-model="body.start" )
                label End
                date-picker(:pickTime="true", format="yyyy-mm-dd hh:ii", v-model="body.end" )
            .row.column.text-right
              ActionButton(:action="addPass") Add
      .card
        .inner-content
          h2 Passes
          base-list(:component="component", :dataLoader="dataLoader")

        //.inner-content
          h2 Passes
            .row
              .column
                .label PD{{pass.id}}
              .column
                .label Start
                .value {{pass.start}}
              .column
                .label End
                .value {{pass.end}}
              .column
                label Capabilities
                .value {{pass.capabilities.routes.join(", ")}}

</template>
<script type="text/babel">
import ModalReveal from "../structure/foundation/ModalReveal";
import LoadingSpinner from "../structure/LoadingSpinner";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import ActionButton from "../structure/ui/ActionButton";
import MaggieHelper from "../../maggieHelper";
import DatePicker from "../structure/DatePicker.vue";
import BaseList from "../../pages/backoffice/BaseList.vue";
import {EventBus} from "../../eventBus";

export default {
  name: 'ManageDriverPass',
  components: {
    BaseList,
    DatePicker,
    ActionButton,
    LoadingSpinner,
    ModalReveal

  },
  data() {
    return {
      body: {
        name: null,
        start: null,
        end: null,
        driver_id: this.driver_id,
        capabilities: {
          routes: []
        },
      },
      mesh: [],
      pass: null,
      component: require('src/components/backoffice/PassDriver.vue'),

    }
  },
  created() {
    KeplerBackofficeSdk.transit.get((data) => this.mesh = data)
  },
  methods: {
    dataLoader(callback, page, resultsPerPage,) {
      KeplerBackofficeSdk.driverPass.list(page, resultsPerPage).get(this.driver_id, (data) => {
        callback(data)
      })
    },
    addPass() {
      return KeplerBackofficeSdk.driverPass.make(this.body, () => {
        MaggieHelper.notification("Pass added")
        EventBus.$emit('reload-list')
      })
    }
  },
  props: {
    driver_id: {
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    capabilities() {
      return Object.entries(this.mesh).map(([key, value]) => ({
        value: key,
        label: value.name
      }));
    },
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component.component-backoffice-driver-notes
  .description
    white-space: pre
</style>



// WEBPACK FOOTER //
// ManageDriverPass.vue?0e4725f1